import { css, GridContainer, mixins, styled } from '@bob/library'
import {
  SharedBackground,
  SharedBackgroundProps,
  spotCampaignBreakpoint,
} from '@websrc/Spot/Campaign/Components/SpotCampaignShared.style'

export const Wrapper = styled.div`
  ${mixins.padding(20)}
  ${mixins.media.max.custom(spotCampaignBreakpoint, 'screen')} {
    display: none;
  }
`

type DesktopBackgroundProps = SharedBackgroundProps & {
  hasBackgroundImage: boolean
  hasRegularImage: boolean
  url?: string | null
  hasVideo: boolean
  hasTextContent: boolean
}

export const Background = styled(GridContainer)<DesktopBackgroundProps>`
  ${SharedBackground};
  min-height: 500px;
  display: flex;
  align-items: center;

  ${({ hasVideo, hasTextContent, hasRegularImage }: DesktopBackgroundProps) =>
    hasTextContent && !hasRegularImage && !hasVideo
      ? ''
      : css`
          justify-content: space-around;
        `}

  ${({ hasBackgroundImage, url, hasVideo }: DesktopBackgroundProps) =>
    hasBackgroundImage &&
    !hasVideo &&
    css`
      background: url('${url}') center center no-repeat;
      background-blend-mode: multiply;
      background-size: 100%;
      background-size: cover;
    `}
`

export const BackgroundImage = styled.div<{ url?: string }>`
  ${({ url }: { url?: string }) =>
    css`
      background: url('${url}') center center no-repeat;
    `}
  background-blend-mode: multiply;
  background-size: 100%;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

export const AssetCol = styled.div`
  width: 50%;
`

export const ContentWrapper = styled.div<{ isReverse: boolean; hasBackgroundImage: boolean }>`
  padding: 20px 0;
  z-index: 1;
  min-height: inherit;
  position: relative;
  ${({ isReverse }: { isReverse: boolean }) =>
    isReverse &&
    css`
      margin-left: auto;
      order: 1;
    `}
  height: 100%;
  width: ${({ hasBackgroundImage }: { hasBackgroundImage: boolean }) =>
    hasBackgroundImage ? '50%' : '45%'};
  word-break: break-word;
  hyphens: auto;
`
